// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"recommendations-1MBGP","cancel":"cancel-4Xo-X","confirm":"confirm-kM6C2"};